import { useClipboard } from '../Hooks/useClipboars';

export function CopyToClipboard({ className = '', copy }: { className?: string; copy: string }) {
    const { isCopied, copyToClipboard } = useClipboard();

    return (
        <button
            type='button'
            className={`cursor-pointer bg-cover ${isCopied ? 'bg-[image:var(--copied-icon-svg)]' : 'bg-[image:var(--copy-icon-svg)]'} ${className}`}
            onClick={() => copyToClipboard(copy)}
        />
    );
}
